import training from "./reducer";

export default training;
